// Global function to initialize videos in product cards
function initializeVideoCards() {
  setTimeout(function() {
    const productCards = document.querySelectorAll('.product-card');
    productCards.forEach(function(card) {
      // Check if card has already been processed
      if (card.hasAttribute('data-video-initialized')) {
        return;
      }
      
      // Mark as initialized
      card.setAttribute('data-video-initialized', 'true');
      
      // Check if has video (similar logic to product-card.liquid)
      const videoContainer = card.querySelector('.product-card__video-container');
      if (videoContainer) {
        const video = videoContainer.querySelector('video');
        if (video) {
          // Ensure video has correct attributes
          video.setAttribute('autoplay', '');
          video.setAttribute('muted', '');
          video.setAttribute('loop', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('preload', 'metadata');
          video.setAttribute('draggable', 'false');
          
          // Try to load the video
          video.load();
        }
      }
    });
  }, 100);
}

// Initialize videos when page loads
document.addEventListener('DOMContentLoaded', function() {
  initializeVideoCards();
});

// Re-execute when filters are applied
document.addEventListener('facet:update', function() {
  // Wait for content to be updated
  setTimeout(function() {
    initializeVideoCards();
  }, 200);
});

function change_card_colors(input, event) {
  event.preventDefault();    
  var newImageUrl = input.getAttribute('data-image');
  var newSecondaryImageUrl = input.getAttribute('data-secondary');
  var newTitle = input.getAttribute('data-title');
  var newLink = input.getAttribute('data-link');
  var selectedVariantId = input.getAttribute('data-variant-id');
  var newProductId = input.getAttribute('data-product-id');
  var newPrice = input.getAttribute('data-price');

  if (!newImageUrl) return;
  
  var productCard = input.closest('.product-card');
  if (!productCard) return;
  
  // Check if it's a video card and convert to slider
  var videoContainer = productCard.querySelector('.product-card__video-container');
  if (videoContainer) {
    // console.log('Converting video card to image slider');
    convertVideoCardToSlider(productCard, videoContainer);
  }
  
  var primaryImage = productCard.querySelector('.product-card__image--primary');
  if (primaryImage) {
    primaryImage.src = newImageUrl;
    primaryImage.setAttribute('src', newImageUrl);
    if(primaryImage.hasAttribute('data-src')) {
      primaryImage.setAttribute('data-src', newImageUrl);
    }
    if(primaryImage.hasAttribute('srcset')) {
      primaryImage.setAttribute('srcset', newImageUrl);
    }
  }
  
  var secondaryImage = productCard.querySelector('.product-card__image--secondary');
  if (secondaryImage && newSecondaryImageUrl) {
    secondaryImage.src = newSecondaryImageUrl;
    secondaryImage.setAttribute('src', newSecondaryImageUrl);
    if(secondaryImage.hasAttribute('data-src')) {
      secondaryImage.setAttribute('data-src', newSecondaryImageUrl);
    }
    if(secondaryImage.hasAttribute('srcset')) {
      secondaryImage.setAttribute('srcset', newSecondaryImageUrl);
    }
  }
  
  var productTitle = productCard.querySelector('.product-title');
  if (productTitle && newTitle) {
    productTitle.textContent = newTitle;
    if(newLink) {
      productTitle.href = newLink;
    }
  }
  
  var productPrice = productCard.querySelector('.product-price');
  if (productPrice && newPrice) {
    productPrice.textContent = newPrice;
  }
  
  if(newLink) {
    var mediaLinks = productCard.querySelectorAll('.product-card__media');
    mediaLinks.forEach(function(mediaLink) {
      mediaLink.href = newLink;
    });
  }
  
  // Reload Swiper if exists and there are new images
  var swiperContainer = productCard.querySelector('.product-card__swiper');
  // console.log('Swiper container found:', !!swiperContainer);
  
  if (swiperContainer) {
    try {
      // Obter todas as imagens do produto
      var productImages = input.getAttribute('data-images');
      var images = [];
      
      if (productImages) {
        try {
          images = JSON.parse(productImages);
          // console.log('Product images loaded:', images.length);
        } catch (e) {
          console.error('Error parsing product images:', e);
          // Fallback para imagens individuais
          if (newImageUrl) {
            images.push({ url: newImageUrl, alt: newTitle });
          }
          if (newSecondaryImageUrl) {
            images.push({ url: newSecondaryImageUrl, alt: newTitle });
          }
        }
      } else {
        // Fallback para imagens individuais
        if (newImageUrl) {
          images.push({ url: newImageUrl, alt: newTitle });
        }
        if (newSecondaryImageUrl) {
          images.push({ url: newSecondaryImageUrl, alt: newTitle });
        }
      }
      
      console.log('Images to update:', images.length);
      if (images.length > 0) {
        // Destruir Swiper existente se houver
        if (swiperContainer.swiper) {
          swiperContainer.swiper.destroy(true, true);
        }
        
        // Recriar slides com novas imagens
        var swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
        if (swiperWrapper) {
          swiperWrapper.innerHTML = '';
          
          images.forEach(function(image, index) {
            var slide = document.createElement('div');
            slide.className = 'swiper-slide';
            
            // Keep one link per image so each slide goes to the selected product URL
            var mediaAnchor = document.createElement('a');
            mediaAnchor.className = 'product-card__media';
            mediaAnchor.setAttribute('draggable', 'false');
            mediaAnchor.setAttribute('data-instant', '');
            mediaAnchor.href = newLink || '#';

            var img = document.createElement('img');
            img.src = image.url;
            img.alt = image.alt || newTitle;
            img.className = 'product-card__image';
            
            // Adicionar classes de aspect ratio se existirem no card original
            var originalImage = productCard.querySelector('.product-card__image');
            if (originalImage) {
              var aspectClasses = originalImage.className.match(/aspect-\w+/g);
              if (aspectClasses) {
                aspectClasses.forEach(function(cls) {
                  img.className += ' ' + cls;
                });
              }
              
              // Adicionar object-cover se existir
              if (originalImage.className.includes('object-cover')) {
                img.className += ' object-cover';
              }
            }
            
            if (index === 0) {
              img.className += ' product-card__image--primary';
            }
            img.setAttribute('draggable', 'false');
            
            mediaAnchor.appendChild(img);
            slide.appendChild(mediaAnchor);
            swiperWrapper.appendChild(slide);
          });
          
          // Reinicializar Swiper
          setTimeout(function() {
            //console.log('Reinitializing Swiper with', images.length, 'images');
            
            // Check if Swiper is available
            if (typeof Swiper === 'undefined') {
              console.error('Swiper library not loaded');
              return;
            }
            
            var newSwiper = new Swiper(swiperContainer, {
              slidesPerView: 1,
              spaceBetween: 0,
              loop: true,
              allowTouchMove: true,
              grabCursor: true,
              navigation: {
                nextEl: swiperContainer.querySelector('.swiper-button-next'),
                prevEl: swiperContainer.querySelector('.swiper-button-prev'),
              },
              pagination: {
                el: swiperContainer.querySelector('.swiper-pagination'),
                clickable: true,
                dynamicBullets: true,
              },
              breakpoints: {
                768: {
                  allowTouchMove: true,
                  grabCursor: true,
                }
              },
              on: {
                init: function() {
                  //console.log('Swiper initialized successfully');
                }
              }
            });
            
            // Store Swiper reference
            swiperContainer.swiper = newSwiper;
            //console.log('Swiper reinitialized successfully');
          }, 100);
        }
      }
    } catch (e) {
      console.error('Error updating Swiper with new images:', e);
    }
  }
  
  var swatchWrapper = input.closest('.color_swatches--wrapper');
  if (swatchWrapper) {
    var allSwatches = swatchWrapper.querySelectorAll('.custom-swatch');
    allSwatches.forEach(function(item) {
      item.classList.remove('checked');
    });
  }
  input.classList.add('checked');

  var variantData = input.getAttribute('data-variants');
  if (variantData) {
    try {
      var variants = JSON.parse(variantData);
      var variantContainer = productCard.querySelector('.product-card__variant-container');
      if (variantContainer) {
        var html = '<div class="variant-box"><ul class="variant-list">';
        variants.forEach(function(variant) {
          html += '<li data-color="' + (variant.option1 ? variant.option1.toLowerCase() : '') + '">';
          html += '<product-form>';
          html += '<form method="post" action="/cart/add" id="product-form-main-' + newProductId + '-' + variant.id + '" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data">';
          html += '<input type="hidden" name="form_type" value="product">';
          html += '<input type="hidden" name="utf8" value="✓">';
          html += '<input type="hidden" name="id" value="' + variant.id + '">';
          html += '<button type="submit" class="variant-item ' + (variant.available ? 'available' : 'unavailable') + '" ' + (variant.available ? '' : 'disabled') + '>';
          html += variant.title;
          html += '</button>';
          html += '</form>';
          html += '</product-form>';
          html += '</li>';
        });
        html += '</ul></div>';
        variantContainer.innerHTML = html;
      }
    } catch (e) {
      console.error('Error al parsear las variantes:', e);
    }
  }
}

function change_shop_the_look_colors(input, event) {
  event.preventDefault();
  var newImageUrl = input.getAttribute('data-image');
  var newSecondaryImageUrl = input.getAttribute('data-secondary');
  var newTitle = input.getAttribute('data-title');
  var newLink = input.getAttribute('data-link');
  var newPrice = input.getAttribute('data-price');
  var variantData = input.getAttribute('data-variants');
  if (!newImageUrl) return;
  var productRow = input.closest('.quick-buy-product-row');
  if (!productRow) return;

  var primaryImage = productRow.querySelector('.quick-buy-product__image img');
  if (primaryImage) {
    primaryImage.src = newImageUrl;
    if (primaryImage.hasAttribute('srcset')) primaryImage.srcset = newImageUrl;
  }
  var secondaryImage = productRow.querySelector('.product-card__image--secondary');
  if (secondaryImage && newSecondaryImageUrl) {
    secondaryImage.src = newSecondaryImageUrl;
    if (secondaryImage.hasAttribute('srcset')) secondaryImage.srcset = newSecondaryImageUrl;
  }
  var productTitle = productRow.querySelector('.product-title');
  if (productTitle && newTitle) {
    productTitle.textContent = newTitle;
    productRow.setAttribute('data-product-title', newTitle);
    if (newLink) productTitle.href = newLink;
  }
  var productPrice = productRow.querySelector('.product-price');
  if (productPrice && newPrice) productPrice.textContent = newPrice;

  var swatchWrapper = input.closest('.color_swatches--wrapper');
  if (swatchWrapper) {
    swatchWrapper.querySelectorAll('.custom-swatch').forEach(function(s) {
      s.classList.remove('checked');
    });
  }
  input.classList.add('checked');

  var hiddenInput = productRow.querySelector('input.variant-input') || productRow.querySelector('input[type="hidden"][name$="[id]"]');
  var variantList = productRow.querySelector('.stl-chip-list') || productRow.querySelector('.variant-box .variant-list');
  if (!variantData || !variantList || !hiddenInput) return;

  var variants;
  try {
    variants = JSON.parse(variantData);
  } catch (err) {
    console.error(err);
    return;
  }

  var availableVariants = variants.filter(function(variant) { return variant.available; });
  var isSingleSize = variants.length === 1;
  var autoSelectId = isSingleSize && availableVariants.length === 1 ? String(availableVariants[0].id) : '';
  var fullySoldOut = availableVariants.length === 0;

  productRow.classList.toggle('is-sold-out', fullySoldOut);
  productRow.setAttribute('data-fully-sold-out', fullySoldOut ? 'true' : 'false');
  productRow.setAttribute('data-available-count', String(availableVariants.length));
  productRow.setAttribute('data-single-size', isSingleSize ? 'true' : 'false');
  productRow.classList.remove('is-missing-variant');

  var badge = productRow.querySelector('.quick-buy-product-row__badge');
  var quantityInput = productRow.querySelector('input.quantity-input') || productRow.querySelector('input[name$="[quantity]"]');
  var included = productRow.getAttribute('data-included') !== 'false';
  if (fullySoldOut) {
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'quick-buy-product-row__badge';
      badge.textContent = 'Agotado';
      var stack = productRow.querySelector('.stl-row-main') || productRow.querySelector('.v-stack');
      if (stack) stack.appendChild(badge);
    }
    hiddenInput.value = '';
    hiddenInput.disabled = true;
    if (quantityInput) quantityInput.disabled = true;
  } else {
    if (badge) badge.remove();
    hiddenInput.disabled = !included;
    if (quantityInput) quantityInput.disabled = !included;
  }

  variantList.innerHTML = '';
  variants.forEach(function(variant) {
    var li = document.createElement('li');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'stl-chip ' + (variant.available ? 'is-available' : 'is-sold');
    btn.textContent = variant.title;
    btn.dataset.variantId = variant.id;
    btn.dataset.variantTitle = variant.title;
    btn.dataset.available = variant.available ? 'true' : 'false';
    if (!variant.available) {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
    } else if (autoSelectId && String(variant.id) === autoSelectId) {
      btn.classList.add('is-selected');
    }
    li.appendChild(btn);
    variantList.appendChild(li);
  });

  hiddenInput.value = autoSelectId;
  if (newTitle) hiddenInput.setAttribute('data-product-title', newTitle);

  var onlyLeftHint = productRow.querySelector('[data-stl-only-left]');
  if (onlyLeftHint) {
    if (!isSingleSize && availableVariants.length === 1 && !autoSelectId) {
      onlyLeftHint.hidden = false;
      onlyLeftHint.textContent = 'Solo queda la talla ' + availableVariants[0].title + '.';
    } else {
      onlyLeftHint.hidden = true;
    }
  }

  var sectionRoot = productRow.closest('.shopify-section');
  document.dispatchEvent(new CustomEvent('stl:variants-rebuilt', {
    detail: {
      row: productRow,
      sectionRoot: sectionRoot
    }
  }));
}

// ============================================================================
//  APP ORBE
// ============================================================================

function cleanUrl(url) {
  try {
    const urlObj = new URL(url);
    const cleanParams = new URLSearchParams();
    
    for (const [key, value] of urlObj.searchParams.entries()) {
      if (key === 'country') {
        cleanParams.set(key, value);
      } else if (key !== 'country' || !cleanParams.has('country')) {
        cleanParams.set(key, value);
      }
    }
    
    const cleanUrl = urlObj.origin + urlObj.pathname;
    const queryString = cleanParams.toString();
    
    return queryString ? cleanUrl + '?' + queryString : cleanUrl;
  } catch (e) {
    console.error('Error cleaning URL:', e);
    return url;
  }
}

function setOrbeCookies(countryCode, languageCode) {
  try {
    let shopDomain = (typeof orbito !== 'undefined' && orbito.getCountryDomain) 
      ? (orbito.getCountryDomain() || window.location.hostname.replace(/^www\./, '')) 
      : window.location.hostname.replace(/^www\./, '');
    
    if (countryCode) {
      document.cookie = `mdApp_countryCodeDomain=${countryCode}; domain=${shopDomain}; path=/; max-age=${60 * 60 * 24 * 60}; SameSite=Lax`;
      //console.log(`Cookie Orbe definido: mdApp_countryCodeDomain=${countryCode}`);
    }
    
    if (languageCode) {
      document.cookie = `mdApp_showRecommendationLang=${languageCode}; domain=${shopDomain}; path=/; max-age=${60 * 60 * 24 * 60}; SameSite=Lax`;
      //console.log(`Cookie Orbe definido: mdApp_showRecommendationLang=${languageCode}`);
    }
  } catch (e) {
    console.error('Error setting Orbe cookies:', e);
  }
}

function handleLocalizationChange(event, type, value) {
  event.preventDefault();
  
  try {
    const form = event.target.closest('form');
    if (!form) {
      console.error('Form not found');
      return;
    }
    
    
    const currentUrl = window.location.href;
    const cleanCurrentUrl = cleanUrl(currentUrl);
    
  
    let newUrl;
    if (type === 'country_code') {
     
      const urlObj = new URL(cleanCurrentUrl);
      urlObj.searchParams.set('country', value);
      newUrl = urlObj.toString();
      
   
      setOrbeCookies(value, null);
      
      //console.log(`Country changed to: ${value}`);
      //console.log(`New URL: ${newUrl}`);
      
    } else if (type === 'locale_code') {
     
      newUrl = cleanCurrentUrl;
      
      setOrbeCookies(null, value);
      
      //console.log(`Language changed to: ${value}`);
    }
    
    setTimeout(() => {
 
      if (newUrl && newUrl !== currentUrl) {
        window.location.href = newUrl;
      } else {
      
        window.location.reload();
      }
    }, 100);
    
  } catch (e) {
    console.error('Error processing localization change:', e);

    window.location.reload();
  }
}


function initializeLocalizationSelectors() {
  try {
    const countrySelectors = document.querySelectorAll('button[name="country_code"]');
    const languageSelectors = document.querySelectorAll('button[name="locale_code"]');
    
    
    countrySelectors.forEach(selector => {
      if (!selector.hasAttribute('data-localization-initialized')) {
        selector.setAttribute('data-localization-initialized', 'true');
        selector.addEventListener('click', (e) => {
          handleLocalizationChange(e, 'country_code', selector.value);
        });
        //console.log(`Country selector initialized: ${selector.value}`);
      }
    });
    
 
    languageSelectors.forEach(selector => {
      if (!selector.hasAttribute('data-localization-initialized')) {
        selector.setAttribute('data-localization-initialized', 'true');
        selector.addEventListener('click', (e) => {
          handleLocalizationChange(e, 'locale_code', selector.value);
        });
        //console.log(`Language selector initialized: ${selector.value}`);
      }
    });
    
    //console.log(`Initialized: ${countrySelectors.length} country selectors, ${languageSelectors.length} language selectors`);
    
  } catch (e) {
    console.error('Error initializing localization selectors:', e);
  }
}


document.addEventListener('DOMContentLoaded', function() {
  initializeLocalizationSelectors();
});


document.addEventListener('facet:update', function() {
  setTimeout(initializeLocalizationSelectors, 200);
});


if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(function(mutations) {
    let shouldReinitialize = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (
            node.querySelector('button[name="country_code"]') || 
            node.querySelector('button[name="locale_code"]')
          )) {
            shouldReinitialize = true;
          }
        });
      }
    });
    
    if (shouldReinitialize) {
      setTimeout(initializeLocalizationSelectors, 100);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// ============================================================================
// VIDEO CARD TO IMAGE SLIDER
// ============================================================================
function convertVideoCardToSlider(productCard, videoContainer) {
  try {
    // Find the parent container of the video
    var mediaLink = videoContainer.closest('.product-card__media');
    if (!mediaLink) return;
    
    // Create Swiper structure
    var swiperHTML = `
      <div class="product-card__swiper swiper">
        <div class="swiper-wrapper">
          <!-- Slides will be added dynamically -->
        </div>
        <div class="swiper-pagination"></div>
        <button class="swiper-button-prev" aria-label="Previous image"></button>
        <button class="swiper-button-next" aria-label="Next image"></button>
      </div>
    `;
    
    // Replace video with Swiper
    mediaLink.innerHTML = swiperHTML;
    
    // Add basic styles for Swiper
    var style = document.createElement('style');
    style.textContent = `
      .product-card__swiper {
        position: relative;
        width: 100%;
        height: 100%;
      }
      .product-card__swiper .swiper-slide {
        position: relative;
        width: 100%;
        height: 100%;
      }
      .product-card__swiper .product-card__image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .product-card__swiper .swiper-pagination {
        position: absolute;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
      }
      .product-card__swiper .swiper-button-prev,
      .product-card__swiper .swiper-button-next {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 10;
        width: 30px;
        height: 30px;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 50%;
        border: none;
        cursor: pointer;
      }
      .product-card__swiper .swiper-button-prev {
        left: 10px;
      }
      .product-card__swiper .swiper-button-next {
        right: 10px;
      }
    `;
    document.head.appendChild(style);
    
    // Add class to indicate it was converted
    productCard.classList.add('video-converted-to-slider');
    
    //console.log('Video card converted to slider structure');
    
  } catch (e) {
    console.error('Error converting video card to slider:', e);
  }
}

// ============================================================================
// FIN  APP ORBE
// ============================================================================
 


// ============================================================================
//   COUNTDOWN HEADER APP
// ============================================================================
setTimeout(() => {
const countdownWrapper = document.querySelector('.essential_countdown_annoucement_bar_wrapper')
const heightObserver = document.querySelector('header')

if (countdownWrapper && heightObserver) {
  heightObserver.classList.add('essential_countdown_active')
}
}, 500)


let countdownTimerInterval = null;

function cloneCountdownTimer() {
  const sourceDiv = document.querySelector('.cart-drawer__announcement-app-fake');
  const cartDrawer = document.querySelector('cart-drawer');
  
  if (sourceDiv && cartDrawer) {
    const targetDiv = cartDrawer.querySelector('.cart-drawer__announcement-app');
    if (targetDiv) {
      targetDiv.innerHTML = sourceDiv.innerHTML;
    }
  }
}

function startCountdownTimerSync() {
  if (countdownTimerInterval) {
    clearInterval(countdownTimerInterval);
  }
  
  cloneCountdownTimer();
  
  countdownTimerInterval = setInterval(function() {
    cloneCountdownTimer();
  }, 1000);
}

function stopCountdownTimerSync() {
  if (countdownTimerInterval) {
    clearInterval(countdownTimerInterval);
    countdownTimerInterval = null;
  }
}

document.addEventListener('cart:change', function() {
  setTimeout(startCountdownTimerSync, 50);
});

document.addEventListener('cart-drawer:refreshed', function() {
  setTimeout(startCountdownTimerSync, 50);
});

document.addEventListener('cart:refresh', function() {
  setTimeout(startCountdownTimerSync, 100);
});

function setupCartDrawerListeners() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.addEventListener('dialog:after-close', stopCountdownTimerSync);
    cartDrawer.addEventListener('dialog:close', stopCountdownTimerSync);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupCartDrawerListeners);
} else {
  setupCartDrawerListeners();
}

// ============================================================================
//  FIN COUNTDOWN HEADER APP
// ============================================================================



// ============================================================================
//evento compose - add cart
// ============================================================================
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    const button = e.target.closest('button[type="submit"]');
    if (!button) return;

    const wrapper = button.closest('buy-buttons');
    if (!wrapper) return;

    if (!wrapper.classList.contains('buy-buttons')) return;

    if (window.compose) {
      window.compose.dispatchEvent(
        new CustomEvent('goal:add-to-cart-click')
      );
    }
  });
});
// ============================================================================
//FIM evento compose - add cart
// ============================================================================


// ============================================================================
// Swym Back in Stock — abrir modal na aba SMS (uma vez por abertura)
// ============================================================================
(function initSwymSmsDefaultTab() {
  var bound = false;
  var userChoseTab = false;
  var autoSelectDone = false;
  var pendingTimeouts = [];
  var handledModals = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  function clearPending() {
    pendingTimeouts.forEach(clearTimeout);
    pendingTimeouts = [];
  }

  function stopAutoSelect() {
    clearPending();
    autoSelectDone = true;
  }

  function getSmsButton() {
    var modal = document.querySelector('.swym-remind-me');
    return modal ? modal.querySelector('#sms-switch') : null;
  }

  function trySelectSmsTab() {
    if (userChoseTab || autoSelectDone) return;
    var smsBtn = getSmsButton();
    if (!smsBtn) return;
    if (!smsBtn.classList.contains('non-active')) {
      stopAutoSelect();
      return;
    }
    smsBtn.click();
    if (!smsBtn.classList.contains('non-active')) {
      stopAutoSelect();
    }
  }

  function scheduleSmsDefault() {
    clearPending();
    userChoseTab = false;
    autoSelectDone = false;
    [0, 50, 150, 300, 500, 800, 1200, 1800, 2500].forEach(function(ms) {
      pendingTimeouts.push(setTimeout(trySelectSmsTab, ms));
    });
  }

  function onModalAdded(modal) {
    if (handledModals) {
      if (handledModals.has(modal)) return;
      handledModals.add(modal);
    }
    scheduleSmsDefault();
  }

  function bindListeners() {
    if (bound) return;
    bound = true;

    document.addEventListener(
      'click',
      function(e) {
        if (e.target.closest('#email-switch, #sms-switch')) {
          userChoseTab = true;
          stopAutoSelect();
          return;
        }
        if (e.target.closest('.swym-add-to-watchlist')) {
          scheduleSmsDefault();
        }
      },
      true
    );

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type !== 'childList') return;
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('swym-remind-me')) {
            onModalAdded(node);
            return;
          }
          if (node.querySelector) {
            var modal = node.querySelector('.swym-remind-me');
            if (modal) onModalAdded(modal);
          }
        });
        mutation.removedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('swym-remind-me')) {
            userChoseTab = false;
            autoSelectDone = false;
            clearPending();
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  bindListeners();

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(bindListeners);
})();
// ============================================================================
// FIM Swym Back in Stock — aba SMS
// ============================================================================
